import React from "react";
import { Component } from "react";
import Websocket from "react-websocket";
import { getAccessToken } from "../../../services/browserStorage";

class ReactWebSocket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  webSocketConnected = () => {
    // console.log("web socket connected");
  };

  webSocketDisconnected = () => {
    // console.log('web socket disconnected');
  };

  render() {
    const { onMessage, url } = this.props;
    return !this.state.hasError ? (
      <Websocket
        protocol={getAccessToken()}
        onOpen={this.webSocketConnected}
        onClose={this.webSocketDisconnected}
        url={url}
        onMessage={onMessage}
        reconnect={true}
        reconnectIntervalInMilliSeconds={10000}
      />
    ) : (
      <span />
    );
  }
}

export default ReactWebSocket;
